import carService from '@/services/car.service';
import sharedService from "@/services/shared.service";

const state = {
    id: Number,
    isLoading: Boolean,
    carCategories: Object,
    carStatuses: Object,
    carTypes: Object,
    carInfo: Object,
    vignettes: Array,
    notes: Array
};

const getters = {
    isCarLoading: (state) => state.isLoading,
    carCategories: (state) => state.carCategories,
    carStatuses: (state) => state.carStatuses,
    carTypes: (state) => state.carTypes,
    carInfo: (state) => state.carInfo,
    carVignettes: (state) => state.vignettes,
    carNotes: (state) => state.notes
};

const actions = {
    fetchCar({commit}, id) {
        commit('setIsCarLoading', true);
        carService.fetchCarById(id)
            .then(({data}) => {
                commit('setId', data.id);
                commit('setCarInfo', data.carInfo);
                commit('setCarVignettes', data.vignettes);
                commit('setCarNotes', data.notes);
                commit('setIsCarLoading', false);
            })
            .catch(() => commit('setIsCarLoading', false));
    },
    fetchCarEnums({commit}) {
        sharedService.fetchCarEnums()
            .then(({data}) => {
                commit("setCareCategories", data.carCategories);
                commit("setCarTypes", data.carTypes);
                commit("setCarStatuses", data.carStatuses);
            })
    }
};

const mutations = {
    setId: (state, id) => (state.id = id),
    setIsCarLoading: (state, isLoading) => (state.isLoading = isLoading),
    setCareCategories: (state, categories) => (state.carCategories = categories),
    setCarTypes: (state, types) => (state.carTypes = types),
    setCarStatuses: (state, statuses) => (state.carStatuses = statuses),
    setCarInfo: (state, carInfo) => (state.carInfo = carInfo),
    setCarVignettes: (state, vignettes) => (state.vignettes = vignettes),
    setCarNotes: (state, notes) => (state.notes = notes)
};

export default {
    state,
    getters,
    actions,
    mutations
};
